import { scaleTime } from "d3-scale";
import { addDays, format, startOfToday } from "date-fns";
import { css } from "@emotion/css";
import React from "react";
import { useObservable, useObservableState } from "observable-hooks";
import { interval } from "rxjs";

const RightNowLine = ({ scale }) => {
  const pong$ = useObservable(() => interval(60 * 1000));
  const pong = useObservableState(pong$);
  const now = new Date();

  return (
    <div
      className={css`
        position: absolute;
        top: 0;
        width: 100%;
        margin-top: -9px;
        background-color: #e91e63;
        padding-left: 0.2em;
        color: white;
        font-weight: bold;
        font-size: 0.8em;
      `}
      style={{
        transform: `translate3d(0, ${scale(now)}px, 0)`,
      }}
    >
      <span>
        {format(now, "HH")}
        <span
          className={css`
            @keyframes blinker {
              50% {
                opacity: 0;
              }
            }
            animation: blinker 1s linear infinite;
          `}
        >
          :
        </span>
        {format(now, "mm")}
      </span>
    </div>
  );
};

export const HourRuler = ({ dayHeight, isToday }) => {
  const scale = scaleTime()
    .domain([startOfToday(), addDays(startOfToday(), 1)])
    .range([0, dayHeight]);

  return (
    <div
      className={css`
        position: relative;
        height: ${dayHeight}px;
        overflow-y: hidden; /* 20 = scrollbar */
        border-right: 1px solid #cacdd3;
      `}
    >
      {scale.ticks(24).map((d, i) => (
        <div
          key={i}
          className={css`
            position: absolute;
            width: 100%;
          `}
          style={{
            transform: `translate3d(0, ${scale(d)}px, 0)`,
          }}
        >
          <div
            className={css`
              display: flex;
              width: 100%;
            `}
          >
            <div
              className={css`
                margin: auto;
                position: relative;
                top: -0.7em;
                font-size: 0.7em;
                font-weight: bold;
                color: grey;
                text-transform: lowercase;
              `}
            >
              {format(d, "haaa")}
            </div>
          </div>
        </div>
      ))}

      {isToday && <RightNowLine scale={scale} />}
    </div>
  );
};
